import { CountryCode, getCountryCallingCode } from 'libphonenumber-js'

// Those types are basically copy-pasted from @reward-platform/members-api-client

// Maybe ideally we should have a type:types lib centralising those types
// but with the way that it's currently configured trying to import types here
// violates @nx/enforce-module-boundaries https://nx.dev/features/enforce-module-boundaries

type MemberTypesCountryOfResidenceLocation = {
  type: string
  identifier: string
}

type MemberTypesTelecomAddress = {
  deviceType: string
  type: string
  preferenceIndicator?: boolean
  number?: string
  areaCode?: string
  countryDiallingCode?: string
  platformType?: string
}

export const getAccountHolderPhoneNumber = (
  telecomAddresses?: Partial<MemberTypesTelecomAddress>[],
  countryOfResidence?: MemberTypesCountryOfResidenceLocation
) => {
  try {
    const telecomAddress =
      telecomAddresses?.find(({ preferenceIndicator }) => preferenceIndicator) ??
      telecomAddresses?.find(({ deviceType }) => deviceType === 'MOBILE') ??
      telecomAddresses?.find(({ deviceType }) => deviceType === 'PHONE') ??
      telecomAddresses?.[0]

    const countryDiallingCode =
      telecomAddress?.countryDiallingCode ||
      getCountryCallingCode(countryOfResidence?.identifier as CountryCode)

    const phone =
      telecomAddress && countryDiallingCode
        ? `${countryDiallingCode} ${telecomAddress.number}`
        : telecomAddress?.number

    if (!phone) {
      return undefined
    }

    // This logic ensures that we always have a proper phone format regardless of what comes
    // from telecomAddress?.countryDiallingCode
    return phone?.startsWith('+') ? phone : `+${phone}`
  } catch (error) {
    return undefined
  }
}
